export const sleepGoalsPostDef = {
  name: 'sleepGoalsPost',
  instructions: '',
  questions: []
};
